/**
 * sessionStorage key of `AssociationsStore`. In a file of its own so `AuthenticationService` can
 * clear it on sign-out without importing the store, which itself depends on that service.
 */
export const ASSOCIATIONS_STORE_KEY = 'abook-associations-store';
